/**
 * Mapas de entidad lógica ↔ tabla remota (snake_case) y local (camelCase).
 * Centralizan las conversiones para pull, push y merge.
 */

export const ENTITY_TO_REMOTE_TABLE: Record<string, string> = {
  node: 'nodes',
  nodeTemplate: 'node_templates',
  macroSession: 'macro_sessions',
  problemAttempt: 'problem_attempts',
  recallItem: 'recall_items',
  reviewEvent: 'review_events',
  memoryWeights: 'memory_weights',
  conjecture: 'conjectures',
  sleepRecord: 'sleep_records',
  studyGoal: 'study_goals',
  preferences: 'preferences'
};

export const ENTITY_TO_LOCAL_TABLE: Record<string, string> = {
  node: 'nodes',
  nodeTemplate: 'nodeTemplates',
  macroSession: 'macroSessions',
  problemAttempt: 'problemAttempts',
  recallItem: 'recallItems',
  reviewEvent: 'reviewEvents',
  memoryWeights: 'memoryWeights',
  conjecture: 'conjectures',
  sleepRecord: 'sleepRecords',
  studyGoal: 'studyGoals',
  preferences: 'preferences'
};

export function remoteTable(entityType: string): string | null {
  return ENTITY_TO_REMOTE_TABLE[entityType] ?? null;
}

export function localTable(entityType: string): string | null {
  return ENTITY_TO_LOCAL_TABLE[entityType] ?? null;
}

export const ALL_ENTITY_TYPES: string[] = Object.keys(ENTITY_TO_REMOTE_TABLE);